import React from "react";


export const FormSubTitleSection = props => <>
  <h4 class="box-title mt-3">{props.label}</h4>
</>
